/**
 * The privacy and cookies policy an applicant agrees to before opening a fund.
 *
 * The policy itself lives on the marketing site, so it is linked absolutely - this app is served
 * from info.hatzdaka.org. Both values mirror LandingSite/LandingSite.client/src/data/legal-links.ts;
 * keep them in step, because the version is stored with every consent and is what tells the office
 * which wording an applicant actually agreed to.
 *
 * The version below is also checked by the API: /api/users/register refuses a signup whose version
 * is not one of PrivacyPolicyConstants.AcceptedVersions in ViewerCore. Raising it here without
 * raising CurrentVersion there turns coordinator self-registration into a 400.
 */
export const PRIVACY_POLICY_URL = 'https://www.hatzdaka.org/privacy-policy';

/**
 * הכתובת שבאנר העוגיות מקשר אליה (HAT-1081). פר-tenant, כי bro2bro ו-hatzdakaUS
 * הם ארגונים אחרים - קישור למדיניות של מרכז הצדקה שגוי אצלם. ריק = אין עדיין
 * עמוד מדיניות ל-tenant הזה, והקישור מוסתר. משתנה שלא הוגדר כלל נופל לברירת
 * המחדל של מרכז הצדקה, כדי לא לשנות התנהגות קיימת.
 */
export const COOKIE_NOTICE_PRIVACY_POLICY_URL =
  import.meta.env.VITE_PRIVACY_POLICY_URL ?? PRIVACY_POLICY_URL;

export const PRIVACY_POLICY_VERSION = '2026-09.1';

/** כמה זמן הסכמת עוגיות תקפה לפני שנשאל שוב. תואם ל-CONSENT_MAX_AGE_DAYS ב-LandingSite. */
export const CONSENT_MAX_AGE_DAYS = 365;
